import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import CommonButton from "../../commonFields/CommonButton";
import ConfirmationModal from "../../commonModals/ConfirmationModal";
import ROUTES from "../../../constant/routes";
import storage from "../../../utils/storage";
import toast from "../../../utils/toastsMessage";
import PasswordModal from "../../commonModals/PasswordModal";

import { ROLES } from "../../../constant/commonConstants";
import { changePassword } from "../../../services/user";
import { IChangePassowrd } from "../../../interfaces/userInterface";
import { authIntialState, authStore } from "../../../store/authStore";

import "./Sidebar.scss";
import logo from "../../../assets/images/footer-logo.png";
import SVGFiles from "../../SVGFiles";

const Sidebar: React.FC = () => {
  const history = useNavigate();
  const {state:authUser,update:updateAuthUser} = authStore((state) => state);

  const handleLogOut = async () => {
    updateAuthUser(authIntialState)
    storage.removeAll();
    history(ROUTES.ADMIN_LOGIN);
  };



  const { t: translation } = useTranslation();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const changePasswordInfo = async (data: IChangePassowrd) => {
    setLoading(true);
    const res = await changePassword({
      old_password: data?.old_password,
      password: data.password,
    });
    if (res?.data?.success) {
      setShowPasswordModal(false);
      toast.success(translation(res?.data?.message));
    } else {
      toast.error(res?.data?.message ?? "something_went_wrong");
    }
    setLoading(false);
  };
  return (
    <>
      <div className="sidebar">
        <div className="d-flex flex-column h-100 justify-content-between">
          <div>
            <Link
              to={
                authUser.account_type === ROLES.ARTIST
                  ? ROUTES.JOB_REQUEST
                  : ROUTES.DASHBOARD_ADMIN
              }
            >
              <div className="logo ">
                <img src={logo} alt="" />
              </div>
            </Link>
            <ul>
              {authUser.account_type === ROLES.ADMIN && (
                <>
                  {" "}
                  <li
                    className={
                      window.location.pathname === ROUTES.DASHBOARD_ADMIN
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={ROUTES.DASHBOARD_ADMIN}>
                      <h5>
                         <SVGFiles name="dashboadIcon" />
                        {translation("dashboard")}
                      </h5>
                    </Link>
                  </li>
                  <li
                    className={
                      window.location.pathname === ROUTES.USER_LIST
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={ROUTES.USER_LIST}>
                      <h5>
                        <SVGFiles name="userList" />
                        {translation("users_dashboard")}
                      </h5>
                    </Link>
                  </li>
                  <li
                    className={
                      window.location.pathname === ROUTES.PAYMENT_LIST
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={ROUTES.PAYMENT_LIST}>
                      <h5>
                        <SVGFiles name="paymentList" />
                        {translation("dashboard_payments")}
                      </h5>
                    </Link>
                  </li>
                  <li
                    className={
                      window.location.pathname === ROUTES.ADMIN_ORDER_LIST
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={ROUTES.ADMIN_ORDER_LIST}>
                      <h5>
                        <SVGFiles name="orderList" />

                        {translation("dashboard_orders")}
                      </h5>
                    </Link>
                  </li>
                  <li
                    className={
                      window.location.pathname === ROUTES.SHEET_INFORMATION
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={ROUTES.SHEET_INFORMATION}>
                      <h5>
                        <SVGFiles name="sheetInformation" />
                        {translation("sheet_information")}
                      </h5>
                    </Link>
                  </li>
                  <li
                    className={
                      window.location.pathname === ROUTES.SETTINGS
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={ROUTES.SETTINGS}>
                      <h5>
                        <SVGFiles name="settings" />
                        {translation("settings")}
                      </h5>
                    </Link>
                  </li>
                  <li
                    className={
                      window.location.pathname === ROUTES.PACKAGE_DETAIL
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={ROUTES.PACKAGE_DETAIL}>
                      <h5>
                        <SVGFiles name="packageDetails" />
                        {translation("package_detail")}
                      </h5>
                    </Link>
                  </li>
                  <li
                    className={
                      window.location.pathname === ROUTES.SHEET_WEIGHT
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={ROUTES.SHEET_WEIGHT}>
                      <h5>
                        <SVGFiles name="sheetWeight" />
                        {translation("sheet_weight")}
                      </h5>
                    </Link>
                  </li>
                  <li
                    onClick={() => setShowPasswordModal(!showPasswordModal)}
                    className={showPasswordModal ? "active" : ""}
                  >
                    <h5 className="unique-link cursorA">
                      <SVGFiles name="changePassword" />
                      {translation("dashboard_password")}
                    </h5>
                  </li>
                </>
              )}

              {authUser.account_type === ROLES.ARTIST && (
                <>
                  <li
                  className={
                    window.location.pathname === ROUTES.JOB_REQUEST
                      ? "active"
                      : ""
                  }
                >
                  <Link to={ROUTES.JOB_REQUEST}>
                    <div className="d-flex justify-content-between">
                      {" "}
                      <h5>
                        <SVGFiles name="jobRequest" />
                        {translation("dashboard_jobs")}
                      </h5>
                    </div>
                  </Link>
                </li>
                <li
                    className={
                      window.location.pathname === ROUTES.USER_LIST
                        ? "active"
                        : ""
                    }
                  >
                    <Link to={ROUTES.USER_LIST}>
                      <h5>
                        <SVGFiles name="userList" />
                        {translation("users_dashboard")}
                      </h5>
                    </Link>
                  </li>
                </>
              )}
              <div className="p-4">
                <CommonButton
                  className="theme-button primary-btn"
                  type="button"
                  onClick={() => setShowConfirmModal(!showConfirmModal)}
                >
                  <SVGFiles name="adminSidebarLogout" />
                  {translation("dashboard_logout")}
                </CommonButton>
              </div>
            </ul>
          </div>
          <p className="p-4 op-6">{translation("made_by_biz4group")}</p>
        </div>
      </div>

      {showConfirmModal && (
        <ConfirmationModal
          heading="Logout"
          description="logout_modal_description"
          onClickOkay={() => handleLogOut()}
          onClickCancel={() => setShowConfirmModal(false)}
        />
      )}
      {showPasswordModal && (
        <PasswordModal
          closeModal={() => setShowPasswordModal(false)}
          getdata={changePasswordInfo}
          loading={loading}
        />
      )}
    </>
  );
};
export default Sidebar;
